module.exports = __webpack_public_path__ + "img/banner-middle.2969c911.svg";